import React, { useState } from 'react';
import { Grid, LinearProgress } from '@mui/material';
import Tutorial from './components/Tutorial';
import FilterGroup from './Groups/FilterGroup';
import TreatmentGroup from './Groups/TreatmentGroup';
import ContentHeader from '../../components/ContentHeader/ContentHeader';
import FilterGroupTwo from './Groups/FilterGroupTwo';
import EmployeeInformation from './components/EmployeeInformation';
import TreatmentIndividual from './Groups/TreatmentIndividual';
import AccompanimentModel from './view.model';
import ReportGroup from './Groups/ReportGroup';
import { Button } from '@material-ui/core';



function Accompaniment() {

    const {
        filterGroup,
        filterGroup2,
        employeeInformation,
        reportGroup,
        treatmentIndividual,
        larguraDaTela,
        schedule,
        page
    } = AccompanimentModel();




    return (
        <ContentHeader title="Tratamento de pontos">
            <Grid>
                <Button
                    style={{
                        color: '#537cd0',
                        borderRadius: '15px',
                        // textTransform: 'none'
                        marginLeft: page == 1 ? '-350px' : 0
                    }}
                    href='/acompanhamento'

                >
                    Ir para tela antiga
                </Button>
            </Grid>
            <Grid sx={{ display: 'flex', width: '100%' }}>
                <Grid sx={{ width: '100%' }}>
                    <FilterGroup data={filterGroup} />
                </Grid>
                {page == 0 && larguraDaTela > 1656 && (
                    <Grid sx={{ width: '20%' }}>
                        <Tutorial />
                    </Grid>
                )}
            </Grid>

            {page == 1 && (
                <>
                    <FilterGroupTwo data={filterGroup2} />

                    {schedule && (
                        <Grid sx={{ display: 'flex', width: '90%', padding: '40px 0px 0px 0px' }}>
                            <EmployeeInformation data={employeeInformation} />
                            <TreatmentIndividual data={treatmentIndividual} />
                        </Grid>
                    )}

                    <ReportGroup dataReportGroup={reportGroup} />
                </>
            )}
        </ContentHeader>

    )
}

export default Accompaniment;

